import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

const ScrollToTop = () => {
  const { pathname } = useLocation()

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    // Use direct element reference
    window.scrollTo(0, 0)

    // Also reset any scrollable containers
    const contentElements = document.querySelectorAll('[class*="content"]')
    // biome-ignore lint/complexity/noForEach: <explanation>
    contentElements.forEach((element) => {
      if (element instanceof HTMLElement) {
        element.scrollTop = 0
      }
    })
  }, [pathname])

  return null
}

export default ScrollToTop
